import type { ApiGnomeSnapshot } from "@bridge-applications/pb-types";
import {
    GnomeEquipmentItemIdSchema,
    type GnomeEquippedItemIds,
} from "../../schemas/slices/GnomeCustomizationSliceSchema.ts";
import { GNOME_EQUIPMENT_CATALOG } from "./gnomeCustomization.ts";

export const EMPTY_GNOME_EQUIPMENT: GnomeEquippedItemIds = {
    headwear: null,
    beard: null,
    glasses: null,
    shirt: null,
    pants: null,
    footwear: null,
};

export function equippedItemsFromSnapshot(
    snapshot: ApiGnomeSnapshot,
): GnomeEquippedItemIds {
    const equipped: GnomeEquippedItemIds = { ...EMPTY_GNOME_EQUIPMENT };

    for (const slot of snapshot.loadout) {
        const itemId = GnomeEquipmentItemIdSchema.safeParse(slot.itemCode);
        if (!itemId.success) continue;
        const catalogItem = GNOME_EQUIPMENT_CATALOG.find(
            ({ id }) => id === itemId.data,
        );
        if (catalogItem?.category !== slot.slotCode) continue;

        switch (catalogItem.category) {
            case "headwear":
                equipped.headwear = catalogItem.id;
                break;
            case "beard":
                equipped.beard = catalogItem.id;
                break;
            case "glasses":
                equipped.glasses = catalogItem.id;
                break;
            case "shirt":
                equipped.shirt = catalogItem.id;
                break;
            case "pants":
                equipped.pants = catalogItem.id;
                break;
            case "footwear":
                equipped.footwear = catalogItem.id;
                break;
        }
    }

    return equipped;
}
